import { put } from 'redux-saga/effects';

import {openWarningException} from "../layouts/actions";

function* onError(msg) {
    yield put(openWarningException(msg))
}

export default onError